import { useAuth } from '../auth/AuthContext';

/**
 * Preferencias de la clínica (Administración → Preferencias; API `GET|PUT /api/preferencias`, `hub_settings` clave
 * `preferencias`). Llegan con la sesión (`auth/session` y el login), así que cada pantalla ya las tiene al abrirse.
 *
 * `periodo_default`: con qué periodo ABRE toda vista con fechas. Un preset del selector (`PeriodPicker` → PRESETS) o
 * 'todo' (el "Todo" del selector, que ahí vale ''). Por default, 30 días. Cada pantalla lo toma con
 * `useState(usePeriodoInicial())`: el selector lo sigue cambiando en el momento.
 */
export interface Preferencias { periodo_default: string }
export const PERIODOS_DEFAULT = ['todo', 'hoy', '7d', '30d', 'mes', 'mes_pasado', '90d', 'anio'] as const;
export const PREFERENCIAS_DEFAULT: Preferencias = { periodo_default: '30d' };

/** La misma limpieza que el API (lib/preferencias.ts): lo que no sea un preset → 30 días. */
export function limpiarPreferencias(p: Partial<Preferencias> | null | undefined): Preferencias {
  const v = typeof p?.periodo_default === 'string' ? p.periodo_default.trim().toLowerCase() : '';
  const periodo = v === '' ? (p?.periodo_default === '' ? 'todo' : '') : v;
  return { periodo_default: (PERIODOS_DEFAULT as readonly string[]).includes(periodo) ? periodo : PREFERENCIAS_DEFAULT.periodo_default };
}

/** El valor que entiende el selector: 'todo' → '' (así lo representa `PeriodPicker`). */
export const periodoDelSelector = (p: Preferencias): string => (p.periodo_default === 'todo' ? '' : p.periodo_default);

/** Con qué periodo abre esta vista: el que eligió la clínica (30 días si no ha elegido). */
export function usePeriodoInicial(): string {
  return periodoDelSelector(useAuth().preferencias);
}
